import {
  mobile_number,
  store_location,
  store_details,
  store_filter,
  category_products,
  cart_order_details,
  cart_quantity,
  login_prescribe_data,
  clear_login_prescribe_data,
} from "./ActionType";

export const mobileReducer = (state = "number", action) => {
  switch (action.type) {
    case mobile_number:
      return action.payload;
    default:
      return state;
  }
};

export const locationReducer = (state = {}, action) => {
  switch (action.type) {
    case store_location:
      return action.payload;
    default:
      return state;
  }
};

export const storeReducer = (state = {}, action) => {
  switch (action.type) {
    case store_details:
      return action.payload;
    default:
      return state;
  }
};

export const storeFIlterReducer = (state = [], action) => {
  switch (action.type) {
    case store_filter:
      return action.payload;
    default:
      return state;
  }
};

export const categoryProductsReducer = (state = {}, action) => {
  switch (action.type) {
    case category_products:
      return action.payload;
    default:
      return state;
  }
};

export const cartOrderDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case cart_order_details:
      return action.payload;
    default:
      return state;
  }
};

export const cartQuantityReducer = (state = 0, action) => {
  switch (action.type) {
    case cart_quantity:
      return action.payload;
    default:
      return state;
  }
};

export const prescribeDataReducer = (state = {}, action) => {
  switch (action.type) {
    case login_prescribe_data:
      return action.payload;
    case clear_login_prescribe_data:
      return null;
    default:
      return state;
  }
};
